import { render, staticRenderFns } from "./BusinessBookingRequestsListView.vue?vue&type=template&id=0e896e74&scoped=true&"
import script from "./BusinessBookingRequestsListView.vue?vue&type=script&lang=ts&"
export * from "./BusinessBookingRequestsListView.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessBookingRequestsListView.vue?vue&type=style&index=0&id=0e896e74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e896e74",
  null
  
)

export default component.exports